// extracted by mini-css-extract-plugin
export default {"slideup":"Login_slideup__qF3cc","moveInFromLeft":"Login_moveInFromLeft__h87EY","btn":"Login_btn__yeIBu"};